'use client'

import React from 'react'
import { Box, SxProps, Theme } from '@mui/material'
import Image, { ImageProps } from 'next/image'

interface ResponsiveImageProps extends Omit<ImageProps, 'fill' | 'style'> {
  aspectRatio: string
  objectFit?: 'contain' | 'cover'
  sx?: SxProps<Theme>
}

const ResponsiveImage: React.FC<ResponsiveImageProps> = ({
  aspectRatio,
  objectFit = 'contain',
  sx,
  ...imageProps
}) => (
  <Box sx={{ position: 'relative', width: '100%', aspectRatio, ...sx }}>
    <Image fill style={{ objectFit }} {...imageProps} />
  </Box>
)

export default ResponsiveImage
